import { Download, FileText, Presentation } from "lucide-react";
import { Button } from "@/components/ui/button";

const SLIDES = 25;
const pad = (n) => String(n).padStart(2, "0");

export default function PitchDeckPage() {
  return (
    <div className="min-h-screen bg-canvas" data-testid="pitch-deck-page">
      <main className="mx-auto max-w-[1100px] px-6 py-14 max-sm:px-4 max-sm:py-8">
        <p className="font-display text-sm font-semibold text-brand">Onboard</p>
        <h1 className="mt-6 font-display text-4xl font-medium text-ink max-sm:text-[28px]">Onboard pitch deck</h1>
        <p className="mt-3 max-w-2xl text-ink-secondary">
          The hiring operating system for law firms: the problem, the market, the product (screening, assessments and AI interviews), our principles for responsible AI, the business model and the roadmap. {SLIDES} slides, 16:9, with speaker notes in the PowerPoint version.
        </p>
        <div className="mt-6 flex flex-wrap gap-3">
          <Button asChild data-testid="pitch-download-pptx"><a href="/downloads/Onboard_Pitch_Deck.pptx" download><Presentation size={16} /> Download PowerPoint (.pptx)</a></Button>
          <Button asChild variant="outline" data-testid="pitch-download-pdf"><a href="/downloads/Onboard_Pitch_Deck.pdf" download><FileText size={16} /> Download PDF</a></Button>
          <Button asChild variant="ghost" data-testid="pitch-architecture-link"><a href="/architecture">Architecture and data flow</a></Button>
        </div>
        <ol className="mt-12 grid grid-cols-3 gap-5 max-lg:grid-cols-2 max-sm:grid-cols-1" data-testid="pitch-thumbs">
          {Array.from({ length: SLIDES }, (_, i) => (
            <li key={i} className="overflow-hidden rounded-[6px] border border-line bg-white">
              <img src={`/downloads/pitch-thumbs/slide-${pad(i + 1)}.jpg`} alt={`Slide ${i + 1}`} loading="lazy" className="block w-full" />
            </li>
          ))}
        </ol>
        <p className="mt-10 inline-flex items-center gap-2 text-xs text-ink-muted"><Download size={13} /> Figures in brackets are placeholders to complete before sharing.</p>
      </main>
    </div>
  );
}
